<!--  -->
<template>
  <footer class="Footer-Component">
    <div class="Footer-Component-inner">
      <div class="bottom-links">
        <a
          v-for="(item, index) in bottomLinks"
          :key="index"
          :href="item.url"
          target="_blank"
          class="bottom-links-item"
          rel="noopener"
        >
          {{ $t(item.name) }}
        </a>
      </div>

      <div class="gray-line"></div>
      <div class="bigo-logo"></div>

      <div class="social-list-wrapper">
        <div class="social-list">
          <a
            v-for="(item, index) in socialList"
            :key="index"
            :href="item.url"
            target="_blank"
            :class="['social-item', `icon-${item.name}`]"
            rel="noopener"
            :aria-label="`link-${item.name}`"
          >
          </a>
        </div>
      </div>

      <div class="partnership-links">
        <!-- <div class="partnership-links__title">{{ $t('lang050') }}:</div> -->
        <div class="partnership-links__box">
          <a
            v-for="(item, index) in partnershipLinks"
            :key="index"
            :href="item.url"
            target="_blank"
            :class="['link', `link-${item.name}`]"
            rel="noopener"
            :aria-label="`link-${item.name}`"
          >
          </a>
        </div>
      </div>

      <div class="store-icon">
        <div class="apple-icon" @click="goStore('apple')"></div>
        <div class="google-icon" @click="goStore('google')"></div>
      </div>

      <div class="copyright">
        {{ `Copyright © 2015-${year} Bigo Technology Pte. Ltd.` }}
        <br />All Rights Reserved. User Agreement and Privacy Policy
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    this.socialList = [
      {
        name: 'facebook',
        url: 'https://www.facebook.com/bigoliveapp/'
      },
      {
        name: 'twitter',
        url: 'https://twitter.com/BIGOLIVEapp'
      },
      {
        name: 'instagram',
        url: 'https://www.instagram.com/bigoliveapp/'
      },
      {
        name: 'youtube',
        url: 'https://www.youtube.com/c/bigoliveofficial'
      }
    ];
    this.partnershipLinks = [
      {
        name: 'imo',
        url: 'https://imo.im/'
      },
      {
        name: 'Likee',
        url: 'https://likee.com/'
      },
      {
        name: 'helloyo',
        url: 'https://hello.fun/'
      }
    ];
    this.year = new Date().getFullYear();
    return {
      bottomLinks: [
        {
          name: 'lang045',
          url: 'https://www.bigo.sg'
        },
        {
          name: 'lang003',
          url: '/Introduce/info'
        },
        {
          name: 'lang046',
          url: '/agreement.html'
        },
        {
          name: 'lang047',
          url: '/privacyPolicy.html'
        },
        {
          name: 'lang424',
          url: '/child-safety.html'
        },
        {
          name: 'lang425',
          url: '/anti-bullying-policy.html'
        },
        {
          name: 'lang189',
          url: '/cookiePolicy.html'
        },
        {
          name: 'lang048',
          url: '/legalInquiry.html'
        },
        {
          name: 'lang049',
          url: 'https://blog.bigo.tv'
        },
        {
          name: 'lang426',
          url: '/contact-us.html'
        }
      ]
    };
  },
  mounted() {
    this.getBottomLink();
  },
  methods: {
    goStore(type) {
      let url = 'https://play.google.com/store/apps/details?id=sg.bigo.live';
      if (type === 'apple') {
        url = 'https://itunes.apple.com/app/id1077137248';
      }
      window.open(url, '_blank');
    },
    // 判断是否日本地区
    getIsJapan() {
      const japaneseMap = ['ja', 'ja-jp', 'ja-ja', 'jp', 'jp-jp'];
      const lang = window.navigator.language.toLowerCase();
      let isJapan = japaneseMap.includes(lang);
      window.location.search
        .replace('?', '')
        .split('&')
        .forEach((item) => {
          const kv = item.split('=');
          if (kv[0] === 'lang') {
            isJapan = japaneseMap.includes(kv[1]);
          }
        });

      return isJapan;
    },
    getBottomLink() {
      const isJapan = this.getIsJapan();
      if (isJapan) {
        this.bottomLinks.push({
          name: 'Legal',
          url: '/jpPayment.html'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Footer-Component {
  margin-top: 100px;
  padding: 30px 0;
  padding-bottom: 90px;
  width: 100%;
  // height: 367px;
  background-color: #fff;
  position: relative;
  background-position: center center;
  background-size: contain; // cover会溢出，contain会留空白
  background-repeat: no-repeat;
  // background-image: url('~@/assets/img/white-footer.png');

  .Footer-Component-inner {
    width: 1340px;
    margin: 0 auto;
    position: relative;
    // height: 100%;
  }
}

.social-list-wrapper {
  margin-top: 28px;

  .social-list {
    // display: inline-block;
    // overflow: hidden;

    .social-item {
      display: block;
      float: left;
      width: 32px;
      height: 32px;
      margin-right: 30px;
      overflow: hidden;
      background-size: cover;

      &.icon-facebook {
        background-image: url(~@assets/img/social-logo/facebook-gray.png);
      }

      &.icon-twitter {
        background-image: url(~@assets/img/social-logo/twitter-gray.png);
      }

      &.icon-instagram {
        background-image: url(~@assets/img/social-logo/ig-gray.png);
      }

      &.icon-youtube {
        background-image: url(~@assets/img/social-logo/youtube-gray.png);
      }
    }
  }
}

.bottom-links {
  margin-bottom: 38px;
  margin-right: -57.5px;

  .bottom-links-item {
    font-size: 16px;
    font-weight: 600;
    color: #2f3033;
    line-height: 19px;
    margin-right: 57.5px;
    margin-top: 20px;

    // &::after {
    //   content: '|';
    //   display: inline-block;
    //   margin: 0 50px;
    //   color: #c9cbcd;
    // }

    &:hover {
      color: #0dc;
    }

    // &:last-child {
    //   &::after {
    //     display: none;
    //   }
    // }
  }
}

.partnership-links {
  // text-align: center;

  // .partnership-links__title {
  //   margin-top: 32px;
  //   margin-bottom: 24px;
  //   text-align: center;
  //   font-size: 12px;
  //   color: #8a8f99;
  // }

  .partnership-links__box {
    display: inline-block;
    // overflow: hidden;
    // margin-bottom: 48px;
    margin-left: 30px;

    .link {
      display: block;
      float: left;
      margin-right: 30px;
      width: 32px;
      height: 32px;
      // overflow: hidden;
      background-size: cover;

      &.link-imo {
        background-image: url(~@assets/img/social-logo/imo.png);
        position: relative;

        &::before {
          position: absolute;
          content: '';
          width: 1px;
          height: 20px;
          border: 1px solid #e1e3e6;
          left: -30px;
          top: 7px;
        }
      }

      &.link-Likee {
        background-image: url(~@assets/img/social-logo/likee.png);
      }

      &.link-helloyo {
        background-image: url(~@assets/img/social-logo/helloyo.png);
      }
    }
  }
}

.gray-line {
  width: 100%;
  height: 1px;
  border: 1px solid #e1e3e6;
  margin-bottom: 50px;
}

.bigo-logo {
  width: 236px;
  height: 69px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url(~@assets/mobile/images/slide-big.png);
}

.store-icon {
  position: absolute;
  right: 0;
  bottom: 40px;

  .apple-icon {
    width: 123px;
    height: 36px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url(~@assets/img/social-logo/apple.png);
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
  }

  .google-icon {
    width: 123px;
    height: 36px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url(~@assets/img/social-logo/google.png);
    display: inline-block;
    cursor: pointer;
  }
}

.copyright {
  text-align: right;
  font-size: 10px;
  font-weight: 500;
  color: #2f3033;
  line-height: 18px;
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
